const mobileMenuTrigger = document.querySelector(".mobile-menu__trigger");
const submenuTriggers = document.querySelectorAll(
  ".navigation__item--has-submenu"
);
const mediaLg = window.matchMedia("(min-width: 1024px)");

if (mobileMenuTrigger) {
  const body = document.body;
  const header = document.querySelector(".header");
  const navIcon = document.querySelector(".nav-icon");

  mobileMenuTrigger.addEventListener("click", function () {
    navIcon.classList.toggle("open");
    header.classList.toggle("active");
    body.classList.toggle("overlay-active");
  });
}

if (submenuTriggers.length) {
  [].forEach.call(submenuTriggers, (submenuTrigger) => {
    const anchor = submenuTrigger.querySelector(":scope > a");
    const isMobile = !mediaLg.matches;

    anchor.addEventListener("click", function (e) {
      if (isMobile) {
        e.preventDefault();
        submenuTrigger.classList.toggle("is-active");
      }
    });
  });
}
